import React from 'react';
import { getCurrentPosition } from 'src/services/CordovaService/GeolocationService';

interface GeolocationPositionForDb {
  coords: GeolocationCoordinatesForDb;
  timestamp: string;
}

interface GeolocationCoordinatesForDb {
  latitude: number;
  longitude: number;
  altitude: number | null;
  accuracy: number;
  altitudeAccuracy: number | null;
  heading: number | null;
  speed: number | null;
}

interface Properties {
    value?: GeolocationPositionForDb;
    setValue: (value: GeolocationPositionForDb) => void;
}

const Gps: React.FC<Properties> = ({ value, setValue }) => {
    React.useEffect(() => {
        const onSuccess = (position: GeolocationPosition) => {
            const json = geolocationToJSON(position);
            setValue(json);
        };

        getCurrentPosition(onSuccess);
    }, []);

    function geolocationToJSON(position: GeolocationPosition) {
        return {
            timestamp: new Date(position.timestamp).toUTCString(),
            coords: {
                latitude: position.coords.latitude,
                longitude: position.coords.longitude,
                altitude: position.coords.altitude,
                accuracy: position.coords.accuracy,
                altitudeAccuracy: position.coords.altitudeAccuracy,
                heading: position.coords.heading,
                speed: position.coords.speed
            }
        };
    }

    return (
        // <div className="gps">
        //     <p>Latitude: {value?.latitude}</p>
        //     <p>Longitude: {value?.longitude}</p>
        //     {value && <a href={`https://www.openstreetmap.org/#map=18/${value.latitude}/${value.longitude}`}>Open map</a>}
        // </div>
        <></>
    );
};

export default Gps;
